import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { LocationEvsesCardComponent } from './cards/location-evses-card.component';
import { LocationInfoCardComponent } from './cards/location-info-card.component';

export const EmspBoLocationDetailsView = (): React.JSX.Element => (
  <Stack flex={1} gap={GapEnum.M}>
    <Stack flex={1} gap={GapEnum.M} direction="column">
      <LocationInfoCardComponent />
    </Stack>
    <Stack flex={1} gap={GapEnum.M} direction="column">
      <LocationEvsesCardComponent />
    </Stack>
  </Stack>
);
